import { Box, Stack, Typography, useTheme } from '@mui/material'
import { grey } from '@mui/material/colors'
import { makeStyles } from '@mui/styles'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Business from '../../../../../../api/db/Business'
import { currentAdminbusinessActions } from '../../../../../../store/features/currentBusiness'
import { currentAdminShopActions } from '../../../../../../store/features/currentBusinessShop'
import { selectUserPropsState } from '../../../../../../store/features/user'
import { RootState } from '../../../../../../store/store'
import BodySkeleton from '../../../../common/skeletons/BodySkeleton'
import Table from '../Table'

const tableHeadData=["Shop name", "Total revenue(GH₵)", "Total profit(GH₵)", "Items in shop", "Cash in shop",]

export default function ContentBody(){

    const availableShops = useSelector((state:RootState)=>state.currentBusiness.shops)
    const userId = useSelector(selectUserPropsState)?.uid
    const currentBusiness = useSelector((state:RootState)=>state.currentBusiness.metaData)


    const dispatch = useDispatch()

    const theme = useTheme()
    const useStyles = makeStyles({
        content:{
            flex: 1, 
            border: `.5px solid rgba(255, 255, 255, 0.1)`,
            borderRadius: "4px", 
            minHeight: "420px", 
            backgroundColor: theme.palette.primary.main,
            padding: "1rem"
        },
        searchField:{
            backgroundColor: theme.palette.primary.dark,
            border: `.5px solid rgba(255, 255, 255, 0.1)`,
            padding: ".3rem",
            borderRadius: "3px",
            color: grey[200],
            fontWeight: "regular",
            fontSize: "14px",
            outline: "none"
        }
    })

    const classes = useStyles()

    useEffect(()=>{

        getShops(userId!)
        // eslint-disable-next-line
    }, [])

    const getShops = async (userId:string)=>{
        try {
            const res = await Business.getShops(userId!)
            dispatch(currentAdminbusinessActions.setCurrentBusinessShops(res))
        } catch (error) {
            throw error
        }
    }

    return(
        <>

            {
                !currentBusiness?.name ? <BodySkeleton /> : (

                    <>
                        {
                            availableShops?.length > 0 ? (
                                <Box className={classes.content} >

                                    <Stack
                                        sx={{height: "100%"}}
                                        direction="column"
                                        spacing={2}
                                    >

                                        <Table 
                                            title="Shops"
                                            tableHeadData={tableHeadData}
                                            tableBodyData={availableShops}
                                            handleItemClick={(item)=>{
                                                dispatch(currentAdminShopActions.setCurrentAdminShop(item))
                                            }}
                                        />

                                    </Stack>

                                    
                                </Box>

                            ) : 
                            (
                                <NoShop />
                            )
                        }
                    </>

                )
            }
            
            
        </>
    )

}

function NoShop(){
    return (
        <div className="w-full text-center">
            <Typography variant="subtitle2" sx={{color: "grey.500" }}>
                No shops available.
            </Typography>
        </div>
    )
}


